class OpenAIQuestoesService {
  constructor() {
    this.apiKey = process.env.REACT_APP_OPENAI_API_KEY;
    this.baseURL = 'https://api.openai.com/v1/chat/completions';
  }

  async generateQuestions(params) {
    const {
      materia,
      anoEscolar,
      quantidade = 5,
      tiposQuestao = ['multipla_escolha'],
      topicos = '',
      dificuldade = 'medio'
    } = params;

    try {
      const response = await fetch(this.baseURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.apiKey}`
        },
        body: JSON.stringify({
          model: "gpt-4",
          messages: [
            {
              role: "system",
              content: this.getSystemPrompt()
            },
            {
              role: "user", 
              content: this.getUserPrompt(materia, anoEscolar, quantidade, tiposQuestao, topicos, dificuldade)
            }
          ],
          temperature: 0.7,
          max_tokens: 3000
        })
      });

      if (!response.ok) {
        throw new Error(`Erro na API OpenAI: ${response.status}`);
      }

      const data = await response.json();
      const questoesGeradas = JSON.parse(data.choices[0].message.content);
      return this.formatQuestoes(questoesGeradas.questoes);
    } catch (error) {
      console.error('Erro ao gerar questões:', error);
      throw new Error('Falha ao gerar questões com IA: ' + error.message);
    }
  }

  getSystemPrompt() {
    return `Você é um especialista em educação que cria questões de alta qualidade para testes acadêmicos.

REGRAS IMPORTANTES:
- Gere questões apropriadas para o nível escolar especificado
- Use linguagem clara e adequada à idade dos estudantes
- Para múltipla escolha: sempre 4 alternativas, apenas 1 correta
- Para verdadeiro/falso: afirmações claras e objetivas
- Para dissertativas: perguntas que estimulem pensamento crítico
- Evite pegadinhas desnecessárias
- Foque no aprendizado real, não em decoreba

FORMATO DE RESPOSTA: Retorne APENAS um JSON válido, sem texto adicional.`;
  }

  getUserPrompt(materia, anoEscolar, quantidade, tiposQuestao, topicos, dificuldade) {
    const tiposTexto = tiposQuestao.map(tipo => {
      switch(tipo) {
        case 'multipla_escolha': return 'múltipla escolha';
        case 'verdadeiro_falso': return 'verdadeiro/falso';
        case 'dissertativa': return 'dissertativa';
        default: return tipo;
      }
    }).join(', ');

    return `Gere ${quantidade} questões de ${materia} para ${anoEscolar}.

Configurações:
- Tipos de questão: ${tiposTexto}
- Dificuldade: ${dificuldade}
${topicos ? `- Tópicos específicos: ${topicos}` : ''}

Formato JSON esperado:
{
  "questoes": [
    {
      "questao": "texto da questão aqui",
      "tipo_questao": "multipla_escolha",
      "alternativas": ["Alternativa A", "Alternativa B", "Alternativa C", "Alternativa D"],
      "resposta_correta": "0",
      "explicacao": "breve explicação da resposta correta"
    },
    {
      "questao": "afirmação para verdadeiro ou falso",
      "tipo_questao": "verdadeiro_falso", 
      "alternativas": null,
      "resposta_correta": "verdadeiro",
      "explicacao": "explicação da resposta"
    },
    {
      "questao": "pergunta dissertativa aqui",
      "tipo_questao": "dissertativa",
      "alternativas": null,
      "resposta_correta": null,
      "explicacao": "pontos principais que devem ser abordados na resposta"
    }
  ]
}

IMPORTANTE: Para múltipla escolha, resposta_correta deve ser o índice (0, 1, 2 ou 3).
Para verdadeiro/falso, use "verdadeiro" ou "falso".
Para dissertativa, resposta_correta deve ser null.`;
  }

  formatQuestoes(questoes) {
    return questoes.map(questao => ({
      questao: questao.questao,
      tipo_questao: questao.tipo_questao,
      alternativas: questao.alternativas,
      resposta_correta: questao.resposta_correta,
      ativo: true
      // Removido campo 'explicacao' pois não existe na tabela
    }));
  }

  // Validar questão gerada
  validateQuestion(questao) {
    if (!questao.questao || !questao.tipo_questao) {
      return false;
    }

    if (questao.tipo_questao === 'multipla_escolha') {
      return questao.alternativas && 
             questao.alternativas.length === 4 && 
             questao.resposta_correta !== null;
    }

    if (questao.tipo_questao === 'verdadeiro_falso') {
      return ['verdadeiro', 'falso'].includes(questao.resposta_correta);
    }

    return true; // dissertativa
  }
}

export default new OpenAIQuestoesService();
